import { useHasAccess } from 'lib-shared-access-control';
import { FilterInfo } from 'lib-shared-types-api';

import { AppLink } from 'components/appLink/appLink';

type FilterLinkProps = {
  filter: FilterInfo;
};

/** Renders a filter name as a link (if user has access) or plain text. */
export const FilterLink = ({ filter }: FilterLinkProps): JSX.Element => {
  const hasAccess = useHasAccess('settings.satisfaction');

  if (hasAccess) {
    return (
      <AppLink
        path="/settings/satisfaction/filters/:filterId"
        params={{ path: { filterId: filter.id } }}
      >
        {filter.name}
      </AppLink>
    );
  }

  return <>{filter.name}</>;
};
